import { render, staticRenderFns } from "./templateAddTask.vue?vue&type=template&id=c989aca4&"
import script from "./templateAddTask.vue?vue&type=script&lang=js&"
export * from "./templateAddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports